import axios from 'axios';
import { ServerSideTypes } from '../../common/OperationCommonTypes';
import GroupLocationsType from '../Types';
export namespace SupplierCustomGroupLocationsRequests {
    export interface GetAll {
        name?: string;
        desc?: string;
    }

    export interface Create {
        name: string;
        description: string;
        locations: any;
    }

    export interface Update {
        code: string;
        descr: string;
        equipmentsId: number[];
    }
}

export const SupplierCustomGroupService = {
    get: {
        all: (
            tenant: string,
            data: SupplierCustomGroupLocationsRequests.GetAll,
            serverParams: ServerSideTypes.IParams,
        ) => {
            return axios
                .get<ServerSideTypes.IResult<GroupLocationsType.ILocationsValid>>(
                    '/masterdatasupplier/customLocationGroup/allCustomLocationGroupsByFilters',
                    {
                        params: { tenant, ...data, ...serverParams },
                    },
                )
                .then((response) => response.data);
        },

        groupLocationsById: (tenant: string, id: number, serverParams: ServerSideTypes.IParams) => {
            return axios
                .get<ServerSideTypes.IResult<GroupLocationsType.ILocationsValid>>(
                    `/masterdatasupplier/customLocationGroup/locationsNotInCustomGroup`,
                    { params: { ...serverParams, tenant, locationCustomGroupId: id } },
                )
                .then((response) => response.data);
        },
    },

    create: {
        groupLocations: (tenant: string, data: SupplierCustomGroupLocationsRequests.Create) => {
            return axios.post('/masterdatasupplier/customLocationGroup/insertLocationCustomGroup', data, {
                params: { tenant: tenant },
            });
        },
    },
    update: {
        groupLocations: (tenant: string, id: number, data: SupplierCustomGroupLocationsRequests.Update) => {
            return axios
                .put(`/masterdatasupplier/customLocationGroup/updateLocationCustomGroup`, data, {
                    params: { tenant: tenant },
                })
                .then((response) => response.data);
        },
    },
    delete: {
        groupLocation: (tenant: string, id: number) => {
            return axios
                .delete(`/masterdatasupplier/customLocationGroup/deleteLocationCustomGroup`, {
                    params: { tenant: tenant, groupId: id },
                })
                .then((response) => response.data);
        },
    },
};
